export default __webpack_public_path__ + "static/media/model-s.ed66ecac.jpeg";